import { TAvatar } from "@common";
import { Voice, VoiceItemTypes, VoicesResponse, VoiceTypes } from "./types";
import { CUSTOM_VOICES, ELEVEN_LABS_VOICES } from "../pages/Avatar/constants";

const labelsTranslation = {
	use_case: {
		social_media: "Для социальных сетей",
		"social media": "Для социальных сетей",
		news: "Для новостей",
		narration: "Для озвучки и повествования",
		characters: "Для озвучки персонажей (анимация, игры)",
		conversational: "Для естественного общения",
		informative_educational: "Для озвучивания образовательного контента",
		characters_animation: "Для озвучивания анимационных видео",
		entertainment_tv: "Для озвучивания медиа и TV контента",
		narrative_story: "Для повествования и рассказов",
		advertisement: "Для рекламного контента"
	} as const,
	temper: {
		expressive: "Выразительный",
		confident: "Уверенный",
		soft: "Мягкий",
		upbeat: "Бодрый",
		natural: "Естественный",
		warm: "Тёплый",
		intense: "Энергичный",
		seductive: "Привлекательный",
		articulate: "Разборчивый",
		friendly: "Дружелюбный",
		casual: "Расслабленный",
		deep: "Глубокий",
		authoritative: "Внушающий уважение",
		trustworthy: "Надежный",
	} as const,
};

type UseCaseKey = keyof typeof labelsTranslation.use_case;
type TemperKey = keyof typeof labelsTranslation.temper;

export const translateUseCase = (useCase: string): string => {
	const defaultTranslation = "Для озвучки и повествования";
	return labelsTranslation.use_case[useCase as UseCaseKey] || defaultTranslation;
};

export const translateTemper = (temper: string): string => {
	return labelsTranslation.temper[temper as TemperKey] || temper;
};

export const filterVoicesByGender = (
	voices: VoiceTypes[],
	gender: string,
): VoiceTypes[] => voices.filter((v) => v.gender === gender);

export const mapVoicesToDropItems = (
	voices: VoiceTypes[],
	onClick: (voice: string, ttsEngine: string) => void,
): VoiceItemTypes[] =>
	voices.map((voice) => ({
		value: voice.voice_id,
		description: voice.name,
		onClick,
		useCase: voice.useCase,
		ttsEngine: voice.ttsEngine,
}));

export const normalizeVoices = (json: VoicesResponse): VoiceTypes[] => {
  	if (!Array.isArray(json?.voices)) return [];
  	const parsed: VoiceTypes[] = json.voices
  	.filter(({ name }: Voice) =>
      	ELEVEN_LABS_VOICES.includes(name.toLowerCase() as typeof ELEVEN_LABS_VOICES[number])
    )
  	.map(
    	({ voice_id, name, labels }: Voice) => ({
      		voice_id,
      		name,
      		gender: labels.gender,
      		useCase: labels.use_case,
      		ttsEngine: "elevenlabs_regular",
    	}),
  	);
	
	return parsed;
}
